import classNames from 'classnames';
import styles from './styles/FooterClaimCS.module.scss';
import Router from 'next/router';
import Button from "../utilities/Button";

function handleClick() {
    Router.push(`${typeof window !== "undefined" && window.location.pathname}?spview=VerifyOwnership`);
}

const claimContainerClassName = classNames({
    [styles.claimContainer]: true,
});

export default function FooterClaimCS(props) {
    return (
        <Button onClick={handleClick} className={claimContainerClassName}>
            <div>
                ?
            </div>
            Unclaimed
        </Button>
    )
}
